import { render, staticRenderFns } from "./YzList.vue?vue&type=template&id=1ef12a18&scoped=true&lang=pug&"
import script from "./YzList.vue?vue&type=script&lang=js&"
export * from "./YzList.vue?vue&type=script&lang=js&"
import style0 from "./YzList.vue?vue&type=style&index=0&id=1ef12a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef12a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
